module.exports = __webpack_public_path__ + "static/media/aboutWorkshop.ae0df646.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/workshop/aboutWorkshop.png
// module id = 394
// module chunks = 1 2 3